import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "widgetClose",
  "use": "widgetClose-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"widgetClose\"><path clip-rule=\"evenodd\" d=\"m.8701 8.07282-.530256.5304 1.060516 1.06081.53025-.5304 3.07064-3.0715 3.07065 3.0715.53025.53041 1.06051-1.06081-.53025-.53041-3.07065-3.0715 3.07039-3.07124.53025-.5304-1.06051-1.060813-.53025.530404-3.07039 3.071239-3.07038-3.071234-.53025-.530404-1.060516 1.060808.530256.5304 3.07038 3.07124z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol